/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

import { getAllDepartments } from "../api/departments/departments";

require( './bootstrap' );
require('./old/grotec.js');

// Import the Store and Router
import store from "./../store/grotecStore";
import router from "./router";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue( {
    el: '#shop',

    data() {
        return {
            transitionName: 'slide-left',
            productSearch: ""
        }
    },

    watch: {
        '$route'( to, from ) {
            const toDepth = to.path.split( '/' ).length;
            const fromDepth = from.path.split( '/' ).length;
            this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
        },

        productSearch( value ) {
            this.$store.dispatch( 'productsSearch', value );

            if ( this.$route.name !== 'search' && value.length > 0 ) {
                this.$router.push( { name: 'search' } )
            }
        }
    },

    async created() {
        await this.fetchDepartmentList();
        await this.$store.dispatch('setShopCart', Laravel.cartId);
    },
    
    methods: {
        async fetchDepartmentList() {
            try {
                let departmentsResponse = await getAllDepartments();
                this.$store.commit( 'departments', departmentsResponse.data );
            } catch ( e ) {
                console.error( e );
                this.$snotify.error( 'Problem getting departments' )
            }
        },
    },
    
    store,

    router
} );
